"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbTreeview = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sbTreeNode = _interopRequireDefault(require("./sb-tree-node"));

var _constants = require("./constants");

var _shapes = _interopRequireDefault(require("./shapes"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SbTreeview = /*#__PURE__*/function (_Component) {
  _inherits(SbTreeview, _Component);

  var _super = _createSuper(SbTreeview);

  function SbTreeview(props) {
    var _this;

    _classCallCheck(this, SbTreeview);

    _this = _super.call(this, props);
    _this.id = "sb-treeview-".concat((0, _v.default)());
    _this.nodes = {};
    _this.uniqueName = props.uniqueName;

    _this.flattenNodes(props.nodes);

    _this.unserializeLists({
      checked: props.checked,
      expanded: props.expanded
    });

    _this.handleOnCheck = _this.handleOnCheck.bind(_assertThisInitialized(_this));
    _this.handleOnExpand = _this.handleOnExpand.bind(_assertThisInitialized(_this));
    _this.handleOnSelect = _this.handleOnSelect.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SbTreeview, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var nodes = _ref.nodes,
          checked = _ref.checked,
          expanded = _ref.expanded;

      if (!(0, _isEqual.default)(this.props.nodes, nodes)) {
        // eslint-disable-line react/destructuring-assignment
        this.flattenNodes(nodes);
      }

      this.unserializeLists({
        checked: checked,
        expanded: expanded
      });
    }
    /**
     * Loop through all nodes and its children and format them
     * */

  }, {
    key: "getFormattedNodes",
    value: function getFormattedNodes(nodes) {
      var _this2 = this;

      return nodes.map(function (node) {
        var formatted = _objectSpread({}, node);

        formatted.checked = _this2.nodes[node[_this2.uniqueName]].checked;
        formatted.expanded = _this2.nodes[node[_this2.uniqueName]].expanded;

        if (Array.isArray(node.children) && node.children.length > 0) {
          formatted.children = _this2.getFormattedNodes(formatted.children);
        } else {
          formatted.children = null;
        }

        return formatted;
      });
    }
  }, {
    key: "handleOnCheck",
    value: function handleOnCheck(node) {
      var _this$props = this.props,
          noCascade = _this$props.noCascade,
          onCheck = _this$props.onCheck;
      this.toggleChecked(node, node.checked, noCascade);
      onCheck(this.serializeList(_constants.enumDataConstants.CHECKED));
    }
  }, {
    key: "handleOnExpand",
    value: function handleOnExpand(node) {
      var onExpand = this.props.onExpand;
      this.toggleNode(_constants.enumDataConstants.EXPANDED, node, node.expanded);
      onExpand(this.serializeList(_constants.enumDataConstants.EXPANDED));
    }
  }, {
    key: "handleOnSelect",
    value: function handleOnSelect(nodeValue, nodeLabel) {
      var onSelect = this.props.onSelect;
      onSelect(nodeValue, nodeLabel);
    }
    /**
     * Toggle checked or unchecked state
     * */

  }, {
    key: "toggleChecked",
    value: function toggleChecked(node, isChecked, noCascade) {
      var _this3 = this;

      if (node.children === null || noCascade) {
        // Set the check status of a leaf node or an uncoupled parent
        this.toggleNode(_constants.enumDataConstants.CHECKED, node, isChecked);
      } else {
        // Percolate check status down to all children
        node.children.forEach(function (child) {
          _this3.toggleChecked(child, isChecked);
        });
      }
    }
    /**
     * Execute the toggle
     * */

  }, {
    key: "toggleNode",
    value: function toggleNode(key, node, toggleValue) {
      this.nodes[node[this.uniqueName]][key] = toggleValue;
    }
    /**
     * Clear the nodes
     * */

  }, {
    key: "flattenNodes",
    value: function flattenNodes(nodes) {
      var _this4 = this;

      if (!Array.isArray(nodes) || nodes.length === 0) {
        return;
      }

      nodes.forEach(function (node) {
        _this4.nodes[node[_this4.uniqueName]] = {};

        _this4.flattenNodes(node.children);
      });
    }
    /**
     * Re-create the list into the internal
     * variables to allow manipulating with it
     * */

  }, {
    key: "unserializeLists",
    value: function unserializeLists(lists) {
      var _this5 = this;

      // Reset values to false
      Object.keys(this.nodes).forEach(function (value) {
        Object.keys(lists).forEach(function (listKey) {
          _this5.nodes[value][listKey] = false;
        });
      }); // Unserialize values and set their nodes to true

      Object.keys(lists).forEach(function (listKey) {
        lists[listKey].forEach(function (value) {
          _this5.nodes[value][listKey] = true;
        });
      });
    }
    /**
     * Re-create a list to a separated variable to avoid mutations
     * and pass it to the onChange and onExpand methods
     * */

  }, {
    key: "serializeList",
    value: function serializeList(key) {
      var _this6 = this;

      var list = [];
      Object.keys(this.nodes).forEach(function (value) {
        if (_this6.nodes[value][key]) {
          list.push(value);
        }
      });
      return list;
    }
  }, {
    key: "renderTreeNodes",
    value: function renderTreeNodes(nodes) {
      var _this7 = this;

      var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          expandDisabled = _this$props2.expandDisabled,
          noCascade = _this$props2.noCascade,
          optimisticToggle = _this$props2.optimisticToggle,
          renderCheckboxes = _this$props2.renderCheckboxes,
          selected = _this$props2.selected;
      var treeNodes = nodes.map(function (node) {
        var key = "".concat(node[_this7.uniqueName]);
        var checked = (0, _utils.getCheckState)({
          node: node,
          noCascade: noCascade
        });

        var children = _this7.renderChildNodes(node);

        var nodeDisabled = (0, _utils.getDisabledState)({
          node: node,
          parent: parent,
          disabled: disabled,
          noCascade: noCascade
        });
        var isSelected = (0, _utils.isNodeSelected)({
          value: node[_this7.uniqueName],
          selectedValue: selected
        });
        return /*#__PURE__*/_react.default.createElement(_sbTreeNode.default, {
          key: key,
          checked: checked,
          className: node.className,
          id: node.id,
          disabled: nodeDisabled,
          expandDisabled: expandDisabled,
          expanded: node.expanded,
          label: node.label,
          optimisticToggle: optimisticToggle,
          rawChildren: node.children,
          selected: isSelected,
          treeId: _this7.id,
          renderCheckboxes: renderCheckboxes,
          value: node.value,
          onCheck: _this7.handleOnCheck,
          onExpand: _this7.handleOnExpand,
          onSelect: _this7.handleOnSelect,
          uniqueValue: node[_this7.uniqueName]
        }, children);
      });
      return /*#__PURE__*/_react.default.createElement("ol", null, treeNodes);
    }
  }, {
    key: "renderChildNodes",
    value: function renderChildNodes(node) {
      if (node.children !== null && node.expanded) {
        return this.renderTreeNodes(node.children, node);
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          disabled = _this$props3.disabled,
          id = _this$props3.id,
          nodes = _this$props3.nodes,
          style = _this$props3.style;
      var formattedNodes = this.getFormattedNodes(nodes);
      var treeNodes = this.renderTreeNodes(formattedNodes);
      var containerClassName = (0, _classnames.default)('sb-treeview', {
        'sb-treeview-disabled': disabled
      }, className);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: containerClassName,
        id: id,
        style: style
      }, treeNodes);
    }
  }]);

  return SbTreeview;
}(_react.Component);

exports.SbTreeview = SbTreeview;

_defineProperty(SbTreeview, "propTypes", {
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  nodes: _propTypes.default.arrayOf(_shapes.default).isRequired,
  checked: _propTypes.default.arrayOf(_propTypes.default.string),
  disabled: _propTypes.default.bool,
  expandDisabled: _propTypes.default.bool,
  expanded: _propTypes.default.arrayOf(_propTypes.default.string),
  noCascade: _propTypes.default.bool,
  optimisticToggle: _propTypes.default.bool,
  renderCheckboxes: _propTypes.default.bool,
  selected: _propTypes.default.string,
  style: _propTypes.default.object,
  // eslint-disable-line
  onCheck: _propTypes.default.func,
  onExpand: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  uniqueName: _propTypes.default.string
});

_defineProperty(SbTreeview, "defaultProps", {
  className: null,
  id: null,
  checked: [],
  disabled: false,
  expandDisabled: false,
  expanded: [],
  noCascade: false,
  optimisticToggle: true,
  renderCheckboxes: true,
  selected: null,
  style: null,
  onCheck: function onCheck() {},
  onExpand: function onExpand() {},
  onSelect: function onSelect() {},
  uniqueName: 'value'
});
//# sourceMappingURL=sb-treeview.js.map